import React, { Component } from 'react';
import RichTextEditor from 'react-rte';
import { observer, inject } from 'mobx-react';
import './RichTextEditorRTE.css';

class RichTextEditorRTE extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value ? RichTextEditor.createValueFromString(props.value, 'html') : RichTextEditor.createEmptyValue()
    }
  }

  onChange = value => {
    this.setState({value});

    if (this.props.onChange) {
      this.props.onChange(value.toString('html'));
    }
  }

  render() {
    return (
      <RichTextEditor
        value={this.state.value}
        onChange={this.onChange.bind(this)}
      />
    );
  }
}

export default RichTextEditorRTE;



// WEBPACK FOOTER //
// ./src/views/CreateNewCase/RichTextEditorRTE/RichTextEditorRTE.jsx